import { Chip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const DateRangeChip = (props: any) => {
    return <Chip
        label={`${(props.calendarWidgetDateRange[0]?.getMonth() || 0) + 1}/${props.calendarWidgetDateRange && props.calendarWidgetDateRange[0]?.getDate()}/${props.calendarWidgetDateRange && props.calendarWidgetDateRange[0]?.getFullYear().toString().substring(2)} -
            ${(props.calendarWidgetDateRange[1]?.getMonth() || 0) + 1}/${props.calendarWidgetDateRange && props.calendarWidgetDateRange[1]?.getDate()}/${props.calendarWidgetDateRange && props.calendarWidgetDateRange[1]?.getFullYear().toString().substring(2)}`
        }
        sx={{
            border: "2px #39A2DB solid",
            bgcolor: "#ffffff",
            color: "#39A2DB",
            height: '42px',
            fontSize: '18px',
            lineHeight: '22px',
            borderRadius: '24px'
        }}
        onDelete={props.onDelete}
        deleteIcon={<CloseIcon sx={{ color: "#39A2DB !important" }} />}
    />
}

export default DateRangeChip;